(function($, Drupal) {
  'use strict';

  Drupal.behaviors.crownLocations = {
    attach: function(context, settings) {
      $('#toggle-location-filter').once('filter-toggle').each(function() {
        // Add toggle button
        const $btn = jQuery(this);
        const $block = jQuery(this).parent();
        const $form = $block.find('.view-filters');

        $btn.click(function() {
          $btn.toggleClass('open');
          $form.slideToggle(300);
        });

        // Map Funcitionality
        $.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyDphOBseVrNA3GUhmYJccfxMp9XA8dwxxY&v=3.exp&sensor=false', function() {
          $(document).ready(function() {
            let map;
            // Map styles
            let map_styles = [
              {
                'featureType': 'poi',
                'elementType': 'all',
                'stylers': [
                  {
                    'hue': '#000000'
                  },
                  {
                    'saturation': -100
                  },
                  {
                    'lightness': -100
                  },
                  {
                    'visibility': 'off'
                  }
                ]
              },
              {
                'featureType': 'poi',
                'elementType': 'all',
                'stylers': [
                  {
                    'hue': '#000000'
                  },
                  {
                    'saturation': -100
                  },
                  {
                    'lightness': -100
                  },
                  {
                    'visibility': 'off'
                  }
                ]
              },
              {
                'featureType': 'administrative',
                'elementType': 'all',
                'stylers': [
                  {
                    'hue': '#000000'
                  },
                  {
                    'saturation': 0
                  },
                  {
                    'lightness': -100
                  },
                  {
                    'visibility': 'off'
                  }
                ]
              },
              {
                'featureType': 'road',
                'elementType': 'labels',
                'stylers': [
                  {
                    'hue': '#ffffff'
                  },
                  {
                    'saturation': -100
                  },
                  {
                    'lightness': 100
                  },
                  {
                    'visibility': 'off'
                  }
                ]
              },
              {
                'featureType': 'water',
                'elementType': 'labels',
                'stylers': [
                  {
                    'hue': '#000000'
                  },
                  {
                    'saturation': -100
                  },
                  {
                    'lightness': -100
                  },
                  {
                    'visibility': 'off'
                  }
                ]
              },
              {
                'featureType': 'road.local',
                'elementType': 'all',
                'stylers': [
                  {
                    'hue': '#ffffff'
                  },
                  {
                    'saturation': -100
                  },
                  {
                    'lightness': 100
                  },
                  {
                    'visibility': 'on'
                  }
                ]
              },
              {
                'featureType': 'water',
                'elementType': 'geometry',
                'stylers': [
                  {
                    'hue': '#ffffff'
                  },
                  {
                    'saturation': -100
                  },
                  {
                    'lightness': 100
                  },
                  {
                    'visibility': 'on'
                  }
                ]
              },
              {
                'featureType': 'transit',
                'elementType': 'labels',
                'stylers': [
                  {
                    'hue': '#000000'
                  },
                  {
                    'saturation': 0
                  },
                  {
                    'lightness': -100
                  },
                  {
                    'visibility': 'off'
                  }
                ]
              },
              {
                'featureType': 'landscape',
                'elementType': 'labels',
                'stylers': [
                  {
                    'hue': '#000000'
                  },
                  {
                    'saturation': -100
                  },
                  {
                    'lightness': -100
                  },
                  {
                    'visibility': 'off'
                  }
                ]
              },
              {
                'featureType': 'road',
                'elementType': 'geometry',
                'stylers': [
                  {
                    'hue': '#bbbbbb'
                  },
                  {
                    'saturation': -100
                  },
                  {
                    'lightness': 26
                  },
                  {
                    'visibility': 'on'
                  }
                ]
              },
              {
                'featureType': 'landscape',
                'elementType': 'geometry',
                'stylers': [
                  {
                    'hue': '#dddddd'
                  },
                  {
                    'saturation': -100
                  },
                  {
                    'lightness': -3
                  },
                  {
                    'visibility': 'on'
                  }
                ]
              }
            ];
            // Map options
            let mapOptions = {
              zoom: 2,
              mapTypeId: 'roadmap',
              styles: map_styles
            };

            // Set the api fetch URL up with our API key
            // let fetch_geo_url = 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDphOBseVrNA3GUhmYJccfxMp9XA8dwxxY&address=';
            // Create new map, div is located: templates/views/locations/views-view-unformatted--crown-locations-block-1.html.twig
            map = new google.maps.Map($('#map_canvas')[0], mapOptions);

            // Grab locations, the title format used works for fetching geo coding of the locations
            let $addresses = $('.view-id-crown_locations .location');

            // Create area of location strings
            let $addresses_array = [];
            $.each($addresses, function() {
              $addresses_array.push([
                $(this).find('.views-field-title').text().trim(),
                $(this).find('.views-field-field-latitude').text().trim(),
                $(this).find('.views-field-field-longitude').text().trim()
              ]);
            });

            let currentinfo = null;
            let bounds = new google.maps.LatLngBounds();
            // For each location fetch its geo code and create a marker and infowindow, adds open/close functionality to infowindows
            $.each($addresses_array, function(index, _callback) {
              if ($addresses_array[index][1] !== '' && $addresses_array[index][2] !== '') {
                // Fetch
                let $label = $addresses_array[index][0];
                let latlng = new google.maps.LatLng($addresses_array[index][1], $addresses_array[index][2]);

                // Create info window
                const contentString = '<div id="content">' + $label + '</div>';
                const infowindow = new google.maps.InfoWindow({
                  content: contentString
                });

                // Create Marker, attached custom icon
                const marker = new google.maps.Marker({
                  position: latlng,
                  map: map,
                  title: $label,
                  icon: {
                    url: '/themes/_custom/sd/src/img/map-pin.png',
                    scaledSize: new google.maps.Size(27, 36)
                  }
                });

                bounds.extend(marker.position);

                // Infowindow functionality
                marker.addListener('click', () => {
                  infowindow.open({
                    anchor: marker,
                    map,
                    shouldFocus: false
                  });
                });

                // Make Location text clickable items
                const $related_span = $('span:contains("' + $label + '")');
                $related_span.attr('tabindex', 0);
                $related_span.on('click', () => {
                  if (currentinfo) {
                    currentinfo.close();
                  }
                  infowindow.open(map, marker);
                  currentinfo = infowindow;
                  // scroll to map, with active marker
                  $('html, body').animate({scrollTop: $('#map_canvas').position().top + 50}, 300);
                });

                // Event listener for enterkey press
                $related_span.on('keypress', function(e) {
                  if (e.which === 13) {
                    if (currentinfo) {
                      currentinfo.close();
                    }
                    infowindow.open(map, marker);
                    currentinfo = infowindow;
                  }
                  // scroll to map, with active marker
                  $('html, body').animate({scrollTop: $('#map_canvas').position().top + 50}, 300);
                });

                // Add event listener to close all other open info windows, ensuring only the clicked marker displays
                google.maps.event.addListener(marker, 'click', function() {
                  if (currentinfo) {
                    currentinfo.close();
                  }
                  infowindow.open(map, marker);
                  currentinfo = infowindow;
                });

                map.setCenter(bounds.getCenter());

                let url = window.location.href;
                if (url.includes('?') && !url.includes('All')) {
                  map.fitBounds(bounds);
                }
              }
            });
          });
        });
      });
    }
  };

})(jQuery, Drupal);
